import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import PP from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import ExternalRedirect from "./pages/externalRedirect";
import ComplainPolicy from "./pages/ComplainPolicy";
import CookieBanner from "./components/universal/cookieBanner";
import { HelmetProvider } from "react-helmet-async";
import SchemaComponent from "./components/universal/schema-component";
function App() {
  return (
    <HelmetProvider>
      <SchemaComponent />
      <Router>
        <CookieBanner />
        <Routes>
         <Route
  path="/"
  element={<ExternalRedirect />}
/>
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PP />} />
          <Route path="/terms-of-use" element={<TermsofUse />} />
          <Route path="/complain-policy" element={<ComplainPolicy />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
